import { BaseApi } from "./base-api"

export class ShortUrlApi extends BaseApi {
  async resolveCode(code: string) {
    return (await this.get<{ url: string }>(`api/short_url/resolve/${code}`))
      .url
  }
}
